module.exports = __webpack_public_path__ + "assets/img/69only_519.40faf510.jpg";